import { Box } from "@chakra-ui/layout";
import { Flex } from "@chakra-ui/react";
import usePrevisaoOrcamentaria from "core/features/previsao-orcamentaria/hooks/usePrevisaoOrcamentaria ";
import { useState, useEffect, useMemo } from "react";
import PageHeader from "components/Page/PageHeader";
import Container from "components/Container";
import ListingPageHeaderBar from "ui/components/Page/ListingPageHeaderBar";
import useFiltroPrevisaoOrcamentaria from "../../hooks/useFiltroPrevisaoOrcamentaria";
import ItemPrevisaoOrcamentaria from "./../ItemPrevisaoOrcamentaria";
import { BsPlusLg } from "react-icons/bs";
import ModalFormPrevisaoOrcamentaria from "../ModalFormPrevisaoOrcamentaria";
import useDeletePrevisaoOrcamentaria from "core/features/previsao-orcamentaria/hooks/useDeletePrevisaoOrcamentaria";
import { showConfirm, showSuccess } from "infra/helpers/alerta";
import ModalParametroPrevisaoOrcamentaria from "./../ModalParametroPrevisaoOrcamentaria";
import { PrevisaoOrcamentaria } from "core/features/previsao-orcamentaria/typings";
import { useLoading } from "components/GlobalLoading";
import InfiniteScrollCardList from "ui/components/InfiniteScrollCardList";
import { BiCog } from "react-icons/bi";

function ContentPrevisaoOrcamentaria() {
  const { filtro, onChangeFiltro, setFiltro } = useFiltroPrevisaoOrcamentaria();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenParametro, setIsOpenParametro] = useState(false);

  const { mutate: handleDeletePrevisao, isLoading: isLoadingDelete } =
    useDeletePrevisaoOrcamentaria();

  const [editId, setEditId] = useState<string | undefined>();

  const [previsaoDto, setPrevisaoDto] = useState<
    PrevisaoOrcamentaria | undefined
  >();

  const {
    data,
    isLoading,
    refetch,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    isRefetching,
  } = usePrevisaoOrcamentaria(filtro);

  const items = useMemo(() => {
    return (
      data?.pages.reduce(
        (agg: PrevisaoOrcamentaria[], item) => agg.concat(item.items ?? []),
        []
      ) ?? []
    );
  }, [data]);

  const handleDelete = async (id: string) => {
    const { isConfirmed } = await showConfirm();

    if (isConfirmed) {
      handleDeletePrevisao(id, {
        onSuccess: () => {
          showSuccess().then(() => refetch());
        },
      });
    }
  };

  useEffect(() => {
    if (editId) {
      setIsOpen(true);
    }
  }, [editId]);

  useEffect(() => {
    if (!isOpen) {
      setEditId(undefined);
    }
  }, [isOpen]);

  useLoading(isLoadingDelete || isLoading || isRefetching);

  return (
    <>
      <Container>
        <PageHeader
          title="Previsão orçamentária"
          titleButton="Adicionar nova"
          onClick={() => setIsOpen(true)}
          extraButtonTitle="Parâmetros"
          iconExtraButton={<BiCog />}
          extraButtonIconPosition="left"
          extraButtonOnClick={() => setIsOpenParametro(true)}
          buttonProps={{
            leftIcon: (
              <Flex mr={-2} mt="-2px">
                <BsPlusLg />
              </Flex>
            ),
          }}
        />

        <Box>
          <ListingPageHeaderBar
            valueSearch={filtro.search || ""}
            onSearch={(v) => onChangeFiltro({ search: v })}
            showOrderByButton
            orderByOptions={[
              {
                value: "dataInicio",
                label: "Ano",
              },
              {
                value: "createdAt",
                label: "Data de criação",
              },
              {
                value: "nome",
                label: "Descrição",
              },
            ]}
            orderBy={filtro.orderBy}
            onOrderByChange={(orderBy) => {
              setFiltro((state) => ({
                ...state,
                orderBy,
              }));
            }}
            orderDirection={filtro.orderDirection}
            onOrderDirectionChange={(orderDirection) => {
              setFiltro((state) => ({
                ...state,
                orderDirection,
              }));
            }}
          />
        </Box>

        <Box mt={4}>
          <InfiniteScrollCardList
            isLoading={isLoading}
            isFetchingNextPage={isFetchingNextPage}
            data={items}
            hasMore={!!hasNextPage}
            onNext={fetchNextPage}
            emptyDescription="Não há previsões cadastradas"
            RenderCard={({ item }) => (
              <ItemPrevisaoOrcamentaria
                key={item.id}
                item={item}
                setPrevisaoDto={setPrevisaoDto}
                onEdit={setEditId}
                handleDelete={handleDelete}
                refetch={refetch}
              />
            )}
          />
        </Box>

        <ModalFormPrevisaoOrcamentaria
          id={previsaoDto?.id}
          onClose={() => {
            setIsOpen(false);
            setPrevisaoDto(undefined);
          }}
          visible={isOpen}
          data={previsaoDto}
          refetch={refetch}
        />
        <ModalParametroPrevisaoOrcamentaria
          onClose={() => setIsOpenParametro(false)}
          visible={isOpenParametro}
        />
      </Container>
    </>
  );
}

export default ContentPrevisaoOrcamentaria;
